import Image from "next/image";
import { useTranslation } from "next-i18next";

import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";
import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";

import Styled from "./index.styles";

export default function MobileHistoryList({
  historyItemClassName,
}: {
  historyItemClassName: string;
}) {
  const { isMobile } = useCheckIsMobile();
  const { t } = useTranslation(["page-company"]);

  const pointLineImageSrc = isMobile
    ? `/assets/images/company/history-section-point-line-m.webp`
    : "/assets/images/company/history-section-point-line.webp";

  const pointLineImageHeight = isMobile ? 709 : 531;

  return (
    <Styled.historyContainer>
      <Styled.logoAndPointLineImage>
        <div className="image-history-logo">
          <Image
            src={"/assets/images/company/history-section-logo.webp"}
            alt={`section-image`}
            width={isMobile ? 64 : 72}
            height={isMobile ? 64 : 72}
            placeholder="blur"
            blurDataURL="/assets/images/landing/section-image-blur-data.png"
          />
        </div>

        <div className="image-history-point-line">
          <Image
            src={pointLineImageSrc}
            alt={`section-image`}
            width={13}
            height={pointLineImageHeight}
            placeholder="blur"
            blurDataURL="/assets/images/landing/section-image-blur-data.png"
          />
        </div>
      </Styled.logoAndPointLineImage>

      <Styled.historyList layout="mobile">
        <Styled.historyItem top="87px" className={historyItemClassName}>
          <strong>
            2019{ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>
            ・{t("page-company:연혁섹션_2019_항목1")}
            <br />・{t("page-company:연혁섹션_2019_항목2")}
          </p>
        </Styled.historyItem>

        <Styled.historyItem top={"168px"} className={historyItemClassName}>
          <strong>
            2020
            {ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>
            ・{t("page-company:연혁섹션_2020_항목1")}
            <br />・{t("page-company:연혁섹션_2020_항목2")}
            <br />・{t("page-company:연혁섹션_2020_항목3")}
            <br />・{t("page-company:연혁섹션_2020_항목4")}
          </p>
        </Styled.historyItem>

        <Styled.historyItem top={"290px"} className={historyItemClassName}>
          <strong>
            2021
            {ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>
            ・{t("page-company:연혁섹션_2021_항목1")}
            <br />・{t("page-company:연혁섹션_2021_항목2")}
            <br />・{t("page-company:연혁섹션_2021_항목3")}
            <br />・{t("page-company:연혁섹션_2021_항목4")}
          </p>
        </Styled.historyItem>

        <Styled.historyItem top={"432px"} className={historyItemClassName}>
          <strong>
            2022
            {ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>
            ・{t("page-company:연혁섹션_2022_항목1")}
            <br />・{t("page-company:연혁섹션_2022_항목2")}
            <br />・{t("page-company:연혁섹션_2022_항목3")}
            <br />・{t("page-company:연혁섹션_2022_항목4")}
            <br />・{t("page-company:연혁섹션_2022_항목5")}
          </p>
        </Styled.historyItem>

        <Styled.historyItem top={"594px"} className={historyItemClassName}>
          <strong>
            2023
            {ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>・{t("page-company:연혁섹션_2023_항목1")}</p>
          <p>・{t("page-company:연혁섹션_2023_항목2")}</p>
          <p>・{t("page-company:연혁섹션_2023_항목3")}</p>
        </Styled.historyItem>

        <Styled.historyItem top={"756px"} className={historyItemClassName}>
          <strong>
            2024
            {ShipdaCurrentLanguage.currentLanguage === "ko" ? "년" : ""}
          </strong>

          <p>・{t("page-company:연혁섹션_2024_항목1")}</p>
        </Styled.historyItem>
      </Styled.historyList>
    </Styled.historyContainer>
  );
}
